import { Image } from '../common/model';
export const validateAllImagesHaveError = (images: Image[]) =>
	images.every((image: any) => !image.canLoad);
